// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_UoN","cls2":"Configuration-cls2_cGh Configuration-cls1_UoN","primary":"Configuration-primary_ghF","secondary":"Configuration-secondary_M11"};